import { render, staticRenderFns } from "./CrudStepperContent.vue?vue&type=template&id=24b397a0&"
import script from "./CrudStepperContent.vue?vue&type=script&lang=ts&"
export * from "./CrudStepperContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports